import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { GridColDef } from "@mui/x-data-grid";
import TableComponent from "../../components/TableComponent";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { showError } from "../../constants/toasts";
import { useLazyRoleByIdQuery } from "../../service/subAdmin";
import Loader from "../../constants/Loader";
import { formatDubaiDateTime } from "../../utils/dateTime";

interface Permission {
  moduleName: string;
  view: boolean;
  add: boolean;
  edit: boolean;
  delete: boolean;
}

const RoleDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [getRoleById] = useLazyRoleByIdQuery()

  const [loading, setLoading] = useState(false)
  const [permissions, setPermissions] = useState<Permission[]>([])
  const [roleName, setRoleName] = useState("")
  const [createdDate, setCreatedDate] = useState("")

  const goBack = () => {
    navigate(-1);
  };

  const getRoleByIdApi = async () => {
    try {
      setLoading(true)
      const response = await getRoleById({ id }).unwrap();
      setLoading(false)
      if (response.status === 200) {
        setPermissions(response?.data?.permissions || [])
        setRoleName(response?.data?.roleName || "")
        setCreatedDate(response?.data?.createdDate || "")
      }
    } catch (error: any) {
      setLoading(false)
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (id) {
      getRoleByIdApi()
    }
  }, [id])


  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title">
        <h1 className="back_arrow">      <IconButton onClick={() => goBack()}>
          {" "}
          <ArrowBackIcon />{" "}
        </IconButton>Role Detail</h1>

      </div>

      <div className="cards view_page table_cards v2">
        <div className="p_20">
          <div className="gap_p">
            <div className="w_33">
              <h6>Role Name</h6>
              <p>{roleName || '-'}</p>
            </div>
            <div className="w_33">
              <h6>Created Date</h6>
              <p>{createdDate ? formatDubaiDateTime(createdDate) : '-'}</p>
            </div>
          </div>
        </div>
        <div className="sorting_table mt_20">
          <TableContainer sx={{ mt: 4 }} className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Module Name</TableCell>
                  <TableCell align="center">View</TableCell>
                  <TableCell align="center">Add</TableCell>
                  <TableCell align="center">Edit</TableCell>
                  <TableCell align="center">Delete</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {permissions?.length > 0 ? (
                  permissions.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.moduleName}</TableCell>
                      <TableCell align="center">
                        {item.view ? <DoneIcon sx={{ color: "green" }} /> : <CloseIcon sx={{ color: "red" }} />}
                      </TableCell>
                      <TableCell align="center">
                        {item.add ? <DoneIcon sx={{ color: "green" }} /> : <CloseIcon sx={{ color: "red" }} />}
                      </TableCell>
                      <TableCell align="center">
                        {item.edit ? <DoneIcon sx={{ color: "green" }} /> : <CloseIcon sx={{ color: "red" }} />}
                      </TableCell>
                      <TableCell align="center">
                        {item.delete ? <DoneIcon sx={{ color: "green" }} /> : <CloseIcon sx={{ color: "red" }} />}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No permissions found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </MainContainer>
  );
};

export default RoleDetail;
